var map = {
	"./Lexikan_1000px.png": "c80c",
	"./Lexikan_1000px_Putih.png": "f7ef",
	"./Lexikan_2000px.png": "6958",
	"./Lexikan_2000px_Putih.png": "e86b",
	"./Lexikan_500px_Putih.png": "687a",
	"./Logo_500px.png": "608f",
	"./Report_1.jpg": "e738",
	"./Report_1.png": "79d4",
	"./Report_2.jpg": "5b21",
	"./Report_2.png": "1844",
	"./decor/Dekor_FAQ.png": "f37f",
	"./default.png": "6bcd",
	"./demo/Background_Data_Center.jpg": "73a1",
	"./demo/Banner_Homepage.jpg": "1051",
	"./demo/about/Banner_0.jpg": "0c7e",
	"./demo/about/Image_0.jpg": "a5ef",
	"./demo/academic-journal/Image_0.jpg": "96fd",
	"./demo/academic-journal/Image_1.jpg": "78e9",
	"./demo/academic-journal/Image_2.jpg": "e576",
	"./demo/academic-journal/Image_3.jpg": "e128",
	"./demo/academic-journal/Image_4.jpg": "2161",
	"./demo/academic-journal/Image_5.jpg": "8a5b",
	"./demo/academic-journal/Image_6.jpg": "649d",
	"./demo/academic-journal/Image_7.jpg": "09e0",
	"./demo/academic-journal/Image_8.jpg": "539b",
	"./demo/academic-journal/banner.jpg": "66ae",
	"./demo/directory/Banner_0.jpg": "31eb",
	"./demo/directory/Logo_D_01.png": "3336",
	"./demo/directory/Logo_D_02.png": "c0cf",
	"./demo/glossary/Banner_0.jpg": "be6a",
	"./demo/infographic/Infographic_1.jpg": "a9c3",
	"./demo/infographic/Infographic_2.jpg": "dde4",
	"./demo/infographic/Infographic_3.jpg": "e0a9",
	"./demo/legal-analysis/Banner_0.jpg": "6ad8",
	"./demo/legal-analysis/Icon_1.png": "6c27",
	"./demo/legal-analysis/Icon_10.png": "11c0",
	"./demo/legal-analysis/Icon_2.png": "f940",
	"./demo/legal-analysis/Icon_3.png": "0f8d",
	"./demo/legal-analysis/Icon_4.png": "43bb",
	"./demo/legal-analysis/Icon_5.png": "d16c",
	"./demo/legal-analysis/Icon_6.png": "9b84",
	"./demo/legal-analysis/Icon_7.png": "2e73",
	"./demo/legal-analysis/Icon_8.png": "05a9",
	"./demo/legal-analysis/Icon_9.png": "5f64",
	"./demo/legal-analysis/Icon_Download.jpg": "6cbf",
	"./demo/legal-analysis/Image_0.jpg": "d617",
	"./demo/legal-analysis/gear.svg": "db16",
	"./demo/news/0.jpg": "337a",
	"./demo/news/1.jpg": "b6d3",
	"./demo/news/2.jpg": "9a33",
	"./demo/news/3.jpg": "34a5",
	"./demo/news/4.jpg": "d021",
	"./demo/news/5.jpg": "b49e",
	"./demo/news/6.jpg": "9bd7",
	"./demo/news/7.jpg": "384b",
	"./demo/news/8.jpg": "e03f",
	"./demo/news/banner.jpg": "6b38",
	"./error.png": "fa93",
	"./loading.gif": "12ae",
	"./logo.png": "9d64",
	"./nelayan.jpg": "8ab7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";